import React from 'react';
import { siteData } from '../mock';

const Footer = () => {
  return (
    <footer className="bg-black border-t border-white border-opacity-10 py-12 relative overflow-hidden">
      <div className="grain-overlay opacity-20"></div>
      
      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="font-display text-2xl font-bold mb-4 text-pink-accent">
              {siteData.brand}
            </h3>
            <p className="text-sm opacity-70">
              {siteData.tagline}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-mono uppercase tracking-wider mb-4 text-pink-accent">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#about" className="hover:text-pink-accent transition-colors opacity-70 hover:opacity-100">About</a></li>
              <li><a href="#portfolio" className="hover:text-pink-accent transition-colors opacity-70 hover:opacity-100">Portfolio</a></li>
              <li><a href="#blog" className="hover:text-pink-accent transition-colors opacity-70 hover:opacity-100">Blog</a></li>
              <li><a href="#contact" className="hover:text-pink-accent transition-colors opacity-70 hover:opacity-100">Contact</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-mono uppercase tracking-wider mb-4 text-pink-accent">Connect</h4>
            <div className="flex flex-wrap gap-3">
              {siteData.socials.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs px-3 py-1 bg-white bg-opacity-5 border border-white border-opacity-20 rounded-full hover:border-pink-accent hover:text-pink-accent transition-all"
                >
                  {social.name}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-white border-opacity-10 text-center">
          <p className="text-sm opacity-60 font-mono">
            © {new Date().getFullYear()} Biggie Poppins. All rights reserved. Built with chaos & code.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
